export const categories = [
  {
    slug: "xuanhuan",
    name: "玄幻",
    desc: "架空大陆、丹田修炼、热血争锋，主角逆天崛起的热门题材。",
    icon: "ri-sword-line",
  },
  {
    slug: "yanqing",
    name: "言情",
    desc: "都市与古今交织的情感故事，细腻心动与命运纠缠。",
    icon: "ri-heart-3-line",
  },
  {
    slug: "lishi",
    name: "历史",
    desc: "重回烽火年代，权谋将略与家国天下的厚重叙事。",
    icon: "ri-ancient-gate-line",
  },
  {
    slug: "xianxia",
    name: "仙侠",
    desc: "御剑云海、斩妖问长生，古典仙道与东方浪漫。",
    icon: "ri-cloud-line",
  },
  {
    slug: "dushi",
    name: "都市",
    desc: "现代都市里的异能、商战与逆袭，节奏明快爽感十足。",
    icon: "ri-building-2-line",
  },
  {
    slug: "xuanyi",
    name: "悬疑",
    desc: "层层反转的推理与惊悚，真相永远藏在最后一页。",
    icon: "ri-magic-line",
  },
  {
    slug: "kehuan",
    name: "科幻",
    desc: "星际远征、机械觉醒与未来文明的大胆想象。",
    icon: "ri-planet-line",
  },
  {
    slug: "wuxia",
    name: "武侠",
    desc: "快意恩仇、江湖儿女，刀光剑影里的侠义柔情。",
    icon: "ri-focus-2-line",
  },
];

export const hotTags = [
  "热血",
  "轻松",
  "爽文",
  "强强",
  "双洁",
  "重生",
  "穿书",
  "种田",
  "无限流",
  "群像",
  "逆袭",
  "权谋",
  "甜宠",
  "升级流",
  "暗黑",
  "治愈",
];